<template>
    <div class="mainContainer">
        <CustomHeader :text="$t('bonus.mysterybonus')" bgColor="#222428" />:

        <div class="bonus_container">
            <img :src="dataSet.bannerIcon" alt="">

            <div class="day_row">
                <div v-for="(item, index) in dataSet.dayList" :key="index" @click="selectTab(item)">
                    <div class="day_card">
                        <div :class="item.reward_day == dataSet.selectedTab.reward_day ? 'select_content' : 'content'">
                            <img :src="mysterioImages[index].img" alt="" width="50%">
                            <div class="date_text"
                                :style="{ color: item.reward_day == dataSet.selectedTab.reward_day ? '#ffff' : '' }">
                                {{ $t('common.travel') }} <span>{{ item.reward_day }}</span></div>
                            <!-- claimed -->
                            <div v-if="item.reward_data?.rewardCoin" class="select_icon"> <img
                                    src="@/assets/bonus/select.png" alt="">
                            </div>
                            <!-- Expired not claimed -->
                            <!-- <div v-else-if="item.reward_data?.activeStatus === 0 && !item.reward_data?.rewardCoin"
                            class="select_icon"> <van-icon name="checked" size="18"
                                style="background: #d4d4d4; border-radius: 30px; padding:0.1px" color="red" />
                        </div>
                        <div v-else class="select_icon"> <img src="@/assets/bonus/gray_select.png" alt=""></div> -->
                        </div>
                        <div class="arrowIcon">
                            <img style="width: 15px;" v-if="item.reward_day == dataSet.selectedTab.reward_day"
                                src="@/assets/themeThree/down.png" alt="">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div style="padding:15px;">
            <div class="details_card" v-if="dataSet.selectedTab">
                <van-row class="details_content">
                    <div class="middleTop">

                        <van-col span="2">
                        </van-col>
                        <van-col span="12" class="label_text">{{ $t('bonus.registrationTime') }}</van-col>
                        <van-col span="10" class="value_text">{{
                            formatUnixTimestamp(dataSet.mysteryDataConfig?.config?.user_join_date)
                        }}</van-col>

                        <van-col span="2">
                        </van-col>
                        <van-col span="13" class="label_text">{{ $t('bonus.totalDeposit') }}
                            {{ dataSet.selectedTab?.reward_day }}{{ $t('common.days') }}:</van-col>
                        <van-col span="9" class="value_text">R${{
                            formatCurrency(dataSet.selectedTab?.reward_data?.rechargeCoin
                                || 0)
                        }}
                        </van-col>
                    </div>
                    <van-col span="24">
                        <van-row class="middleCard">
                            <van-col span="24" class="text_1">
                                {{ $t('bonus.claimTime') }}
                            </van-col>
                            <van-col span="24">
                                <div class="date_details">
                                    <!-- <img src="@/assets/bonus/smactv2_clock.png" alt=""> -->
                                    {{ formatUnixTimestamp(dataSet.selectedTab?.reward_data?.rewardTime) }}
                                </div>
                            </van-col>
                            <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0" span="24"
                                class="misterio_text">
                                <!-- <img src="@/assets/bonus/smactv2_misterioso.png" alt=""> -->
                                {{ $t('bonus.mysterybonus') }}
                            </van-col>
                            <van-col
                                v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 || dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin"
                                span="24" class="amount">R$
                                <span
                                    :style="{ color: dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#993900' : '' }">
                                    {{ formatCurrency(dataSet.selectedTab?.reward_data?.rewardCoin || 0)
                                    }}</span></van-col>
                            <van-col
                                v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2 || (dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin)"
                                span="24" class="misterio">
                                <img src="@/assets/bonus/weikaishi_tu.png" alt="">
                            </van-col>
                        </van-row>
                    </van-col>
                </van-row>
            </div>
        </div>

        <!-- .................... -->

        <div class="tabel_container" v-if="dataSet.selectedTab">
            <van-row class="tabel_hed">
                <van-col span="11" class="head_alignemnet">{{ $t('bonus.depostiScope') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <!-- <div class="line"></div> -->
                </van-col>
                <van-col span="11" class="head_alignemnet">{{ $t('bonus.mysteryPrize') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in dataSet.selectedTab?.reward_data?.reward_day_data"
                :key="index" :style="{
                    backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(0,0,0,.1)',
                    borderRadius: index === dataSet.selectedTab?.reward_data?.reward_day_data.length - 1 ? '0px 0px 10px 10px' : ''
                }">
                <van-col span="12" class="head_alignemnet">R$
                    <span>{{ item.recharge_min < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_min)) }} ~
                            {{ item.recharge_max < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_max)) }}
                            </span>
                </van-col>
                <van-col span="12" class="head_alignemnet currencyText">R$
                    <span style="font-size: 14px;">{{ item.show_reward_min < 0 ? '\u221E' :
                        formatCurrency(calculateValue(item.show_reward_min)) }} ~ {{ item.show_reward_max < 0
                                ? '\u221E' : formatCurrency(calculateValue(item.show_reward_max)) }} </span></van-col>
            </van-row>
        </div>

        <!-- ........................... -->


        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <van-row style="padding-bottom: 10px;">
                <van-col span="24" class="title">
                    <div>{{ $t('common.eventRule') }}</div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
        <div class="buttonFooter">
            <van-row>
                <!-- Expired -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img"><img src="@/assets/bonus/smactv2_btn_expire.png" alt=""></van-col>
                <!-- Previous claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Today not claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img2"><img src="@/assets/bonus/smactv2_btn_notstart.png" alt=""
                        :class="{ 'pop-animate': dataSet.isPopping }"
                        @click="pickMisteryGift(dataSet.selectedTab?.reward_data?.activeStatus)"></van-col>

                <!-- Today claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Upcoming -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2" span="24" class="statusBar"
                    style="color:#f8d8a7">
                    {{ $t('rewards.notActivated') }}
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THREE } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';

const mysterioImages = ref(MYSTERIO_IMG_THREE)
const router = useRouter()
const props = defineProps<{
    dataSet: BonusData
}>()

const emits = defineEmits(['pickMisteryGift', 'selectTab'])

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}


</script>
<style scoped>
.mainContainer {
    background: linear-gradient(180deg, #1b071c 20.7%, #474386);
    padding-bottom: 60px;
}

.bonus_container {
    padding: 45px 0 0;
    position: relative;
}

.day_row {
    padding: 0 15px;
    /* position: absolute;
    bottom: 25px; */
    margin-top: -45px;
    display: flex;
    flex-direction: row;
}

.bonus_container img {
    width: 100%;
}

.day_card {
    position: relative;
    margin: 0 5px;
}

.day_card img {
    width: 100%;

}

.arrowIcon {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: linear-gradient(0deg, rgba(66, 36, 95, 1) 0%, rgba(114, 62, 41, 1) 100%);
    border-radius: 14px;
    padding: 10px 0;
    border: 2px solid #523536;
    /* box-shadow: 0 4px 20px rgba(255,142,86,.26); */
    margin-bottom: 5px;
    /* border-image: ; */

}

.select_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: linear-gradient(0deg, rgba(126, 80, 194, 1) 0%, rgba(238, 141, 66, 1) 100%);
    border-radius: 14px;
    padding: 10px 0;
    border: 2px solid #a47b5d;
    box-shadow: 0 15px 25px rgba(255, 142, 86, .26);
    margin-bottom: 5px;
    /* border-image: ; */

}

.date_text {
    font-size: 13px;
    color: #937f9a;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: 5px;
    font-weight: 600;
}

.date_text span {
    /* font-size: 20px; */
    padding-left: 5px;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding-top: 10px;
}

.details_card {
    margin-top: -30px;
    position: relative;
    background-image: url("@/assets/themeThree/cotent-bgcolor.png");
    /* background-color: #3e2c23;
    border-radius: 15px;
    border-bottom: 3px solid #dd7a33;
    border-top: 3px solid #dd7a33;
    padding: 5px 0 15px; */
    border-radius: 10px;
    background-size: auto;
    background-size: 100% 100%;
    -webkit-backdrop-filter: blur(50.5px);
    backdrop-filter: blur(50.5px);
    padding: 20px 25px;
}

.details_card img {
    width: 100%;
}

.tab_arrow {
    display: flex;
    justify-content: center;
}

.tab_arrow img {
    width: 25px;
}


.currencyText {
    color: #df8643;
    font-weight: 600;
}


.label_text {
    display: flex;
    align-items: center;
    /* color: rgba(255, 255, 255, 0.65); */
    /* font-size: 3.3vw; */
}

.label_text span {
    color: #FFEE00;
    padding: 0 5px;
}

.value_text {
    display: flex;
    align-items: center;
    justify-content: right;
    /* color: rgba(255, 255, 255, 0.85); */
    /* font-size: 13px; */
}

.text_1 {
    color: #2f2e2d;
    /* font-size: 15px; */
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 0px 35px 25px;
}

.middleTop {
    width: 100%;
    display: contents;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
}

.middleCard {
    border-radius: 10px;
    border: 1px solid #FAA648;
    background: linear-gradient(96deg, #ffcc7d, #b0763e 97.21%);
    padding: 20px 0px;
    font-size: 16px;
}

.date_details {
    color: #2f2e2d;
    font-weight: bold;
    /* font-size: 15px; */
    display: flex;
    align-items: center;
    justify-content: center;
}

.date_details img {
    width: 20px;
    padding: 5px;
}

.misterio_text {
    color: #2f2e2d;
    /* font-weight: bold; */
    /* font-size: 15px; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0px;
}

.misterio_text img {
    width: 20px;
    padding: 5px;
}

.amount {
    color: #2f2e2d;
    /* font-size: 13px; */
    display: flex;
    align-items: center;
    justify-content: center;
}

.amount span {
    font-size: 6vw;
    padding: 0 5px;
    color: #be0527;
    font-weight: bold;

}

.start_img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img img {
    width: 310px;
}

.start_img2 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img2 img {
    width: 310px;
}

.misterio {
    display: flex;
    align-items: center;
    justify-content: center;
}

.misterio img {
    width: 40%;
}

.tabel_container {
    /* border: 2px solid #221b24; */
    border-radius: 10px;
    margin: 0 15px;
}

.tabel_hed {
    background: #3f3050;
    color: #8c8396;
    padding: 15px;
    border-radius: 10px 10px 0px 0px;
    font-size: 16px;
    font-weight: 600;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.line {
    width: 1px;
    height: 15px;
    background-color: rgba(255, 255, 255, 0.15);
}

.tabel_row {
    color: #fff;
    padding: 20px;
    font-size: 13px;
    font-weight: 600;
}

.tabel_row span {
    padding: 0 5px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, .8);
    font-size: 15px;
    display: flex;
    justify-content: flex-start;
    font-weight: 600;
}

.line_text {
    color: rgba(255, 255, 255, .4);
    font-size: 14px;
    padding: 10px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

.statusBar {
    display: flex;
    justify-content: center;
    align-items: center;
    color: green;
    font-weight: bold;
    font-size: 16px;
    background: #0000003b;
    padding: 15px;
    border-radius: 10px;
    margin: 15px 0 10px;
    width: 95vw;
    max-width: 95vw;
    box-sizing: border-box;
}

@media (min-width: 450px) {
    .statusBar {
        width: 425px;
        max-width: 450px;
    }
    .middleTop{
            font-size: 3.8vw;
    }
}

.buttonFooter {
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    background: #393266;
    box-shadow: 0 .0313rem #5f588c inset;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

/* @media(min-width: 400px) {
    .label_text {
        font-size: 13px !important;
    }

    .amount span {
        font-size: 30px !important;
    }
} */
@media(min-width: 450px) {

    .middleCard {
        font-size: 20px
    }

    .middleTop {
        font-size: 17px;
    }

    .amount span {
        font-size: 25px;
    }
}
</style>